/* eslint-disable simple-import-sort/imports */

import './CompteExpert.scss';
//import Button from '@mui/material/Button';
//import SaveIcon from '@mui/icons-material/Save';
//import TextareaAutosize from '@mui/material/TextareaAutosize';
import React, { useEffect, useState } from 'react';
//import UploadImage from '../../../Components/shared/UploadImage';
//import { DrawEmailIcon, DrawMan2ExpertStep2, Step1ExpertRectangle } from '../../../data/SVGs';
//import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import DocAdministra from './SideExpertCompteExpert';
//import { useParams } from 'react-router-dom';
//import TextField from '@mui/material/TextField';
//import { SideBarNavigationFicheExpert } from '../../../Styles/componentStyles';
//import axios from 'axios';
//import { IconButton } from '@mui/material';
import NavBarDonneeProfile from './NavBarDonneeProfile';
//import { TextFieldComponent } from '../../../Components/shared/ReusableSmallComponents';
//import { getNomPrenomClearFromPersoData } from '../../../Utils/utils';
import DonneesPersonnelsExpert, { typeTraitementEnum } from '../../Expert/CompleterProfile/DonneesPersonnelsExpert';
import { useLocation } from 'react-router-dom';
import { getNomPrenomClearFromPersoData } from '../../../Utils/utils';
import { axiosPrivate } from '../../../Api/axios';
import useWindowSize from '../../../hooks/useWindowSize';
import { useTranslation } from 'react-i18next';
import useRole from '../../../hooks/useRole';

function CompteExpert() {
    const location = useLocation();
    console.log('location',location?.state?.type);
    const [nomExpert,setNomExpert]=useState('');
    const {device}=useWindowSize();
    const role=useRole();
    const { i18n } = useTranslation();
    const getTypeTraitement = (role) => {
        const url = window.location.href; // Get the full URL
        if(role=='esn' && url.includes('gestionExperts'))
            return typeTraitementEnum.COLLAB_ESN_UPDATE_EXPERT;
        else if(role=='esn' && url.includes('gestionDossiersCandidats'))
            return typeTraitementEnum.COLLAB_ESN_UPDATE_DOSSIER_CANDIDAT;
        else
            return typeTraitementEnum.ADMIN_UPDATE_EXPERT;
    };

    // useEffect(() => {
    //     if(role)
    //         getTypeTraitement(role);
    // }, [role]);

    const getClientbyId = async () => {
        try {
            // Regular expression pattern to match the id
            const idPattern = /\/gestionExperts\/([^/]+)\//;

            // Extract the id using match() method
            const match = location?.pathname.match(idPattern);
            // Extracted id will be in match[1]

            const id = match ? match[1] : null;
            const response = await axiosPrivate.get('/users/getExpertById/'+id);
            setNomExpert(getNomPrenomClearFromPersoData(response?.data?.persoData));
            console.log('response BE',response?.data);
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        if(location)
            getClientbyId();
    }, [location]);
    return (
        <>
            <div style={{display:'flex',flexDirection:'column',alignItems: 'flex-start',alignSelf:'stretch',gap:'24px'}}>
                <div className='frame5Profile'>{i18n.t('Gestion des Experts')} &gt;<span style={{color:'rgba(39, 45, 60, 1)'}}>{nomExpert} </span> </div>
                <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',alignSelf:'stretch',gap:'24px'}}>
                    <DocAdministra type={location?.state?.type} />
                    <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between',width:'100%',alignItems: 'center',gap:'24px'}}>
                        <NavBarDonneeProfile
                            type={location?.state?.type}
                            role={role}
                        />
                        {role &&
                            <DonneesPersonnelsExpert
                                // typeTraitement={
                                //     (location?.state?.type=='Actif'||typeof location?.state?.type=='undefined' ) ?
                                // typeTraitementEnum.READ_ONLY : typeTraitementEnum.ADMIN_UPDATE_EXPERT}
                                //d'apres la demande de FZ -> Modifiez la logique de cette partie pour permettre à BO de modifier les données, même si l'expert est actif est actif.
                                typeTraitement={getTypeTraitement(role)}
                            />
                        }
                    </div>
                </div>
            </div>
        </>
    );
}
export default CompteExpert;
